import { Fieldset, Textarea, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './CompanyNotesSectionForm.module.scss';
import { Props } from './CompanyNotesSectionForm.types';

const CompanyNotesSectionForm = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <Fieldset legend={t('contacts.company.notesSection', 'Notes')}>
      <div className={styles.content}>
        <Textarea
          label={t('contacts.company.notes', 'Notes')}
          placeholder={t(
            'contacts.company.notesPlaceholder',
            'Ex. Passer par le standard, demander Olivia'
          )}
          autosize
          minRows={2}
          maxLength={2000}
          {...form.getInputProps('notes')}
        />
        <TextInput
          label={t('contacts.company.website', 'Site web')}
          placeholder={t('contacts.company.websitePlaceholder', 'Ex. www.fessart-immobilier.fr')}
          inputMode="url"
          {...form.getInputProps('websiteUrl')}
        />
      </div>
    </Fieldset>
  );
};

export default CompanyNotesSectionForm;
